import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatPaymentFrequencyModel } from 'src/app/model/cat-payment-frecuency.model';
import { CatPaymentTermModel } from 'src/oldApp/model/cat-payment-term.model';
import { CatProductCategoryModel } from 'src/app/model/cat-product-category.model';
import { ComProductEmployeeJobModel } from 'src/app/model/com-product-employee-job.model';
import { CatAfiliateModel, CatAnchorTypeModel, CatBusinessProductModel, CatProductModel, CatPromotionModel, CatSchemaModel, PromotionDTO } from 'src/app/model/other-catalogs-models';
import { CatCategoryProductService } from 'src/oldApp/services/cat-category-product.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatPaymentFrequencyService } from 'src/oldApp/services/cat-payment-frequency.service';
import { CatPaymentTermService } from 'src/oldApp/services/cat-payment-term.service';
import { ComProductEmployeeJobService } from 'src/oldApp/services/com-product-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { ModalConfirmComponent } from 'src/oldApp/shared/modal-confirm/modal-confirm.component';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {
  // estado pagina
  public viewStatus:number=0;
  public formIsLocked:boolean=false;
  public formHeight=0;
  public selectedEmployeeJob:CatEmployeeJobModel=new CatEmployeeJobModel();
  public selectedPaymentFrequency:CatPaymentFrequencyModel=new CatPaymentFrequencyModel();
  public selectedPaymentTerm:CatPaymentTermModel=new CatPaymentTermModel();
  public selectedBusinessProduct:CatBusinessProductModel=new CatBusinessProductModel();
  public selectedAnchorType:CatAnchorTypeModel=new CatAnchorTypeModel();
  public selectedSchema:CatSchemaModel=new CatSchemaModel();
  public selectedProductCategory:CatProductCategoryModel=new CatProductCategoryModel();
  public commission:number=null;
  public active:boolean=true;
  public promotionList:ComProductEmployeeJobModel[]=[];

  // filtros
  public productFilter:string='';
  public afiliateFilter:string='';
  public promoFilter:string='';

  // ajax
  private pendingAfiliateCall:any=null;
  private pendingPromtionCall:any=null;

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public paymentFrequencyCatalog:CatPaymentFrequencyModel[]=[];
  public paymentTermCatalog:CatPaymentTermModel[]=[];
  public paymentTermSubCatalog:CatPaymentTermModel[]=[];
  public businessProductCatalog:CatBusinessProductModel[]=[];
  public anchorTypeCatalog:CatAnchorTypeModel[]=[];
  public productCatalog:CatProductModel[]=[];
  public afiliateCatalog:CatAfiliateModel[]=[];
  public promotionCatalog:CatPromotionModel[]=[];
  public schemaCatalog:CatSchemaModel[]=[];
  public productCategoryCatalog:CatProductCategoryModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private employeeJobService:CatEmployeeJobService,
    private paymentFrequencyService:CatPaymentFrequencyService,
    private paymentTermService:CatPaymentTermService,
    private otheCatalogsService:OtherCatalogsService,
    private productCategoryService:CatCategoryProductService,
    private productEmployeeJobServie:ComProductEmployeeJobService,
    private modalService:NgbModal,
    private creator:CreatorService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
    this.formHeight=window.innerHeight-140;
  }

  // PANEL FORMULARIO
  updateEmployeeJob=()=> {
    this.selectedPaymentFrequency=new CatPaymentFrequencyModel();
    this.selectedPaymentTerm=new CatPaymentTermModel();
    this.selectedBusinessProduct=new CatBusinessProductModel();
    this.selectedAnchorType=new CatAnchorTypeModel();
    this.productCatalog=[];
    this.productFilter='';
    this.afiliateCatalog=[];
    this.afiliateFilter='';
    this.promotionCatalog=[];
    this.promoFilter='';
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();
  }
  updatePaymentFrequency=()=> {
    this.selectedPaymentTerm=new CatPaymentTermModel();
    this.selectedBusinessProduct=new CatBusinessProductModel();
    this.selectedAnchorType=new CatAnchorTypeModel();
    this.productCatalog=[];
    this.productFilter='';
    this.afiliateCatalog=[];
    this.afiliateFilter='';
    this.promotionCatalog=[];
    this.promoFilter='';
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();

    this.paymentTermSubCatalog=this.paymentTermCatalog.filter(term=> term.periodId===this.selectedPaymentFrequency.comnPayFreqId);
  }
  updatePaymentTerm=()=> {
    this.selectedBusinessProduct=new CatBusinessProductModel();
    this.selectedAnchorType=new CatAnchorTypeModel();
    this.productCatalog=[];
    this.productFilter='';
    this.afiliateCatalog=[];
    this.afiliateFilter='';
    this.promotionCatalog=[];
    this.promoFilter='';
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();
  }
  updateBusinessLine=()=> {
    this.selectedAnchorType=new CatAnchorTypeModel();
    this.productCatalog=[];
    this.productFilter='';
    this.afiliateCatalog=[];
    this.afiliateFilter='';
    this.promotionCatalog=[];
    this.promoFilter='';
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();
    // this.otheCatalogsService.getListAnchorType(this.selectedBusinessProduct)
    //   .pipe(
    //     tap((resp:any)=> {
    //       if(resp.status===200 && resp.data) this.anchorTypeCatalog=resp.data;
    //       else throwError;
    //     }),
    //     catchError(error=> {
    //       console.log(error);
    //       this.viewStatus=-1;
    //       return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
    //     })
    //   )
    //   .subscribe();
  }
  updateAnchor=()=> {
    this.productCatalog=[];
    this.productFilter='';
    this.afiliateCatalog=[];
    this.afiliateFilter='';
    this.promotionCatalog=[];
    this.promoFilter='';
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedAnchorType.businessProductId=this.selectedBusinessProduct;
    if(this.selectedAnchorType.anchorTypeId) {
      // this.otheCatalogsService.getListProduct(this.selectedAnchorType)
      //   .pipe(
      //     tap((resp:any)=> {
      //       if(resp.status===200 && resp.data) this.productCatalog=resp.data.sort(this.sortProducts);
      //       else throwError;
      //     }),
      //     catchError(error=> {
      //       console.log(error);
      //       this.viewStatus=-1;
      //       return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      //     })
      //   )
      //   .subscribe();
    }
  }
  selectProduct=(product:CatProductModel)=> {
    if(!this.formIsLocked) {
      this.afiliateCatalog=[];
      this.afiliateFilter='';
      this.promotionCatalog=[];
      this.promoFilter='';
      this.selectedSchema=new CatSchemaModel();
      this.commission=null;
      product.checked=!product.checked;
      this.productCatalog=this.productCatalog.sort(this.sortProducts);
  
      // buscar convenios
      let products=JSON.parse(JSON.stringify(this.productCatalog.filter(p=> p.checked)));
      if(products.length>0) {
        products.forEach(p=> {
          p.catBusinessProduct=this.selectedBusinessProduct;
          p.catAnchorType=this.selectedAnchorType;
          delete p.checked;
        });
        if(this.pendingAfiliateCall) this.pendingAfiliateCall.unsubscribe();
        // this.pendingAfiliateCall=this.otheCatalogsService.getListAfiliate(products)
        //   .pipe(
        //     tap((resp:any)=> {
        //       if(resp && resp.status===200 && resp.data) this.afiliateCatalog=resp.data.sort(this.sortAfiliates);
        //       else throwError;
        //     }),
        //     catchError(error=> {
        //       console.log(error);
        //       this.viewStatus=-1;
        //       return of(this.toastr.error('Ocurrió un error al buscar productos.'));
        //     })
        //   )
        //   .subscribe();
      }
    }
  }
  selectAfiliate=(afiliate:CatAfiliateModel)=> {
    if(!this.formIsLocked) {
      this.promotionCatalog=[];
      this.promoFilter='';
      this.selectedSchema=new CatSchemaModel();
      this.commission=null;
      this.selectedProductCategory=new CatProductCategoryModel();
      afiliate.checked=!afiliate.checked;
      this.afiliateCatalog=this.afiliateCatalog.sort(this.sortAfiliates);
      
      // buscar promociones
      let products=JSON.parse(JSON.stringify(this.productCatalog.filter(p=> p.checked)));
      products.forEach(p=> {
        delete p.checked;
      });
      let afiliates=JSON.parse(JSON.stringify(this.afiliateCatalog.filter(a=> a.checked)));
      afiliates.forEach(a=> {
        delete a.checked;
      });
      if(afiliates.length>0) {
        let promotion=new PromotionDTO();
        promotion.catBusinessProduct=this.selectedBusinessProduct;
        promotion.catAnchorType=this.selectedAnchorType;
        promotion.financingTypes=products;
        promotion.catAfiliates=afiliates;
        if(this.pendingPromtionCall) this.pendingPromtionCall.unsubscribe();
        // this.pendingPromtionCall=this.otheCatalogsService.getListFinancingsByObjPromotion(promotion)
        //   .pipe(
        //     tap((resp:any)=> {
        //       if(resp && resp.status===200 && resp.data) this.promotionCatalog=resp.data.sort(this.sortPromotions);
        //       else throwError;
        //     }),
        //     catchError(error=> {
        //       console.log(error);
        //       this.viewStatus=-1;
        //       return of(this.toastr.error('Ocurrió un error al buscar promociones.'));
        //     })
        //   )
        //   .subscribe();
      }
    }
  }
  selectPromotion=(promotion:CatPromotionModel)=> {
    if(!this.formIsLocked) {
      promotion.checked=!promotion.checked;
      this.promotionCatalog=this.promotionCatalog.sort(this.sortPromotions);
    }
  }
  updateSchema=()=> {
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();
  }
  updateCommission=e=> this.commission=Number(e);
  updateProductCategory=()=> {}
  toggleActive=()=> this.active=!this.active;
  confirmSave=()=> {
    let promotionList:ComProductEmployeeJobModel[]=[];
    // poner producto a las promociones
    // forkJoin(this.promotionCatalog.filter(pro=> pro.checked).map(pro=> {
    //   let promoUchecked={...pro};
    //   delete promoUchecked.checked;
    //   return this.otheCatalogsService.getProductByPromotion(promoUchecked)
    // }))
    // .pipe(
    //   tap((resp:any)=> {
    //     if(resp.every(a=> a)) {
    //       console.log('poniendo datos a promociones')
    //       this.promotionCatalog.filter(pro=> pro.checked).forEach((pro, ind)=> {
    //         let proCopy=JSON.parse(JSON.stringify(pro));
    //         delete proCopy.checked;
    //         // seleccionar categoria
    //         let category=this.selectedSchema.commissionSchemaId===3?this.selectedProductCategory:this.productCategoryCatalog.find(cat=> cat.productCategoryId===5);
    //         delete category.createDate;
    //         delete category.modifDate;
    //         // procesar promocion
    //         let promoListItem=this.creator.newComProductEmployeeJobModel();
    //         promoListItem.BusinessProductId=this.selectedBusinessProduct;
    //         promoListItem.CatAnchorType=this.selectedAnchorType;
    //         promoListItem.EmployeeJobId=this.selectedEmployeeJob;
    //         promoListItem.ProductosCOEId=resp[ind].data;
    //         promoListItem.PromotionIdExt=proCopy;
    //         promoListItem.afiliateId=proCopy.CatAfiliate.vafiliateId;
    //         promoListItem.paymentId=this.selectedPaymentTerm.paymentId;
    //         promoListItem.ProductCategoryId=category;
    //         promoListItem.SchemaId=this.selectedSchema;
    //         promoListItem.commission=this.commission;
    //         promotionList.push(promoListItem);
    //       });
    //       console.log(promotionList);
    //     }
    //     else throwError;
    //   }),
  
    //   // buscando promociones ya existentes
    //   switchMap(()=> this.productEmployeeJobServie.checkIfExists(promotionList)),
    //   tap((resp:any)=> {
    //     console.log('checando existencia')
    //     console.log(resp)
    //     let selPromoNum=resp.data.length;
    //     let existPromoNum=resp.data.filter(pro=> pro.exist).length;
    //     let text=selPromoNum===1? 'Se guardará una promoción.':
    //       selPromoNum>=2?'Se guardarán '+selPromoNum+' promociones.':
    //       '';
    //     if(existPromoNum===1) text+='<br><br><strong>Se sobreescribirá una promoción.</strong>';
    //     if(existPromoNum>=2)  text+='<br><br><strong>Se sobreescribirán '+existPromoNum+' promociones.</strong>';

    //     let modalRef=this.modalService.open(ModalConfirmComponent, {centered:true, backdrop:'static', keyboard:false});
    //     modalRef.componentInstance.header='¿Está seguro de usar este esquema?';
    //     modalRef.componentInstance.text=text;
    //     modalRef.componentInstance.acceptText='Aceptar';
    //     modalRef.componentInstance.cancelText='Cancelar';
    //     modalRef.result.then(
    //       data=> console.log(data),
    //       reason=> { if(reason==='accept') this.processPromotions(); }
    //     );
    //   }),
    // )
    // .subscribe();


  }
  processPromotions=()=> {
    let selectedPromotions=this.promotionCatalog.filter(pro=> pro.checked).map(pro=> {
      let proClone={...pro};
      delete proClone.checked;
      return proClone;
    });

    this.viewStatus=0;
    // llamar productos
    // forkJoin(selectedPromotions.map(pro=> this.otheCatalogsService.getProductByPromotion(pro)))
    //   .pipe(
    //     tap((resp:any)=> {
    //       if(resp.every(a=> a)) {
    //         selectedPromotions.forEach((pro, ind)=> {
    //           // seleccionar categoria
    //           if(this.selectedSchema.commissionSchemaId===3) {
    //             // TODO
    //             this.selectedProductCategory=this.productCategoryCatalog.find(cat=> cat.productCategoryId===5);
    //             delete this.selectedProductCategory.createDate;
    //             delete this.selectedProductCategory.modifDate;
    //           }
    //           // procesar promocion
    //           let promoListItem=this.creator.newComProductEmployeeJobModel();
    //           promoListItem.BusinessProductId=this.selectedBusinessProduct;
    //           promoListItem.CatAnchorType=this.selectedAnchorType;
    //           promoListItem.EmployeeJobId=this.selectedEmployeeJob;
    //           promoListItem.ProductosCOEId=resp[ind].data;
    //           promoListItem.PromotionIdExt=pro;
    //           promoListItem.SchemaId=this.selectedSchema;
    //           promoListItem.afiliateId=pro.CatAfiliate.vafiliateId;
    //           promoListItem.paymentId=this.selectedPaymentTerm.paymentId;
    //           promoListItem.ProductCategoryId=this.selectedProductCategory;
    //           promoListItem.commission=this.selectedSchema.commissionSchemaId===5?this.commission:null;
    //           this.promotionList.push(promoListItem);
    //         });
    //       }
    //       else throwError;
    //     }),
    //     switchMap(()=> this.productEmployeeJobServie.saveAll(this.promotionList)),
    //     tap((resp:any)=> {
    //       if(resp) {
    //         this.getCatalogs();
    //         this.toastr.success('Las promociones se guardaron correctamente.');
    //       }
    //       else throwError;
    //     }),
    //     catchError(error=> {
    //       console.log(error);
    //       this.viewStatus=1;
    //       return of(this.toastr.error('Ocurrió un error al guardar promociones.'));
    //     })
    //   )
    //   .subscribe();
  }

  // HELPERS
  employeeJobError=()=> !this.selectedEmployeeJob || !this.selectedEmployeeJob.employeeJobId;
  paymentFrequencyError=()=> !this.selectedPaymentFrequency || !this.selectedPaymentFrequency.comnPayFreqId;
  paymentTermError=()=> !this.selectedPaymentTerm || !this.selectedPaymentTerm.paymentId ;
  businessProductError=()=> !this.selectedBusinessProduct || !this.selectedBusinessProduct.businessProductId;
  anchorTypeError=()=> !this.selectedAnchorType || !this.selectedAnchorType.anchorTypeId;
  schemaError=()=> !this.selectedSchema || !this.selectedSchema.commissionSchemaId;
  productCategoryError=()=> this.selectedSchema.commissionSchemaId===3 && (!this.selectedProductCategory || !this.selectedProductCategory.productCategoryId);
  commissionError=()=> this.selectedSchema.commissionSchemaId===5 && (this.commission!==0 && !this.commission);
  disableSchema=()=> this.promotionCatalog.filter(pro=> pro.checked).length<=0;
  sortProducts=(a, b)=> {
    let aValue=(a.checked?0:1)+'-'+a.vfinancingTypeDesc;
    let bValue=(b.checked?0:1)+'-'+b.vfinancingTypeDesc;
    return aValue>bValue?1:aValue<bValue?-1:0;
  }
  sortAfiliates=(a, b)=> {
    let aValue=(a.checked?0:1)+'-'+a.vafiliateDesc;
    let bValue=(b.checked?0:1)+'-'+b.vafiliateDesc;
    return aValue>bValue?1:aValue<bValue?-1:0;
  }
  sortPromotions=(a, b)=> {
    let aValue=(a.checked?0:1)+'-'+a.vfinancingId;
    let bValue=(b.checked?0:1)+'-'+b.vfinancingId;
    return aValue>bValue?1:aValue<bValue?-1:0;
  }

  // INFO
  getCatalogs=()=> {
    // limpiar formulario
    this.selectedEmployeeJob=new CatEmployeeJobModel();
    this.selectedPaymentFrequency=new CatPaymentFrequencyModel();
    this.selectedBusinessProduct=new CatBusinessProductModel();
    this.selectedAnchorType=new CatAnchorTypeModel();
    this.productCatalog=[];
    this.afiliateCatalog=[];
    this.promotionCatalog=[];
    this.selectedSchema=new CatSchemaModel();
    this.commission=null;
    this.selectedProductCategory=new CatProductCategoryModel();

    // forkJoin(
    //   this.employeeJobService.getAllActive(),
    //   this.paymentFrequencyService.getAllActive(),
    //   this.paymentTermService.getAllActive(),
    //   this.otheCatalogsService.getListBusinessProduct(),
    //   this.otheCatalogsService.getListSchema(),
    //   this.productCategoryService.getAllActive()
    // )
    // .pipe(
    //   tap(([employeeJobResp, paymentFrequencyResp, paymentTermResp, bpResp, schemaResp, prodCategoryResp]:[any, any, any, any, any, any])=> {
    //     this.employeeJobCatalog=employeeJobResp;
    //     this.paymentFrequencyCatalog=paymentFrequencyResp;
    //     this.paymentTermCatalog=paymentTermResp;
    //     this.businessProductCatalog=bpResp.data;
    //     this.schemaCatalog=schemaResp;
    //     this.productCategoryCatalog=prodCategoryResp;
    //     this.viewStatus=1;
    //   }),
    //   catchError(error=> {
    //     console.log(error);
    //     this.viewStatus=-1;
    //     return of(this.toastr.error('Ocurrió un error al buscar catálogos.'))
    //   })
    // )
    // .subscribe();
  }
}